import { ProtocolContentData } from "../../protocol";
export default class PilotReleasedData extends ProtocolContentData {
    name;
    freeText;
    ladderPosition;
    released;
    constructor(name, ladderPosition, released, freeText) {
        super();
        this.name = name;
        this.ladderPosition = ladderPosition;
        this.freeText = freeText;
        this.released = released;
    }
}
//# sourceMappingURL=PilotReleasedData.js.map